import React, { } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Container, Row, NavLink, Col, Nav, Navbar, Collapse, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Steps } from 'antd';
import { FaChevronUp, FaCheckCircle } from 'react-icons/fa';
import './WizardMenu.css';
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";

function WizardMenu({ wizardDetails, pageReload }) {
    const location = useLocation();
    const [defaultFarmId, setDefaultFarmId] = useLocalStorage('defaultFarmId', '');
    const [defaultFarmName, setDefaultFarmName] = useLocalStorage('defaultFarmName', '');
    const [defaultFarmUniqueId, setDefaultFarmUniqueId] = useLocalStorage('defaultFarmUniqueId', '');

    const [isAddArchiveItem, setIsAddArchiveItem] = useLocalStorage('isAddArchiveItem', '');
    const [isAddEditItem, setIsAddEditItem] = useLocalStorage('isAddEditItem', '');
    const [isCreateNewAction, setIsCreateNewAction] = useLocalStorage('isCreateNewAction', '');
    const [isSubmitEvidenceCloseAction, setIsSubmitEvidenceCloseAction] = useLocalStorage('isSubmitEvidenceCloseAction', '');
    const [isAddDeleteDocument, setIsAddDeleteDocument] = useLocalStorage('isAddDeleteDocument', '');
    const [saveRightsForNonItemFieldsAndTables, setSaveRightsForNonItemFieldsAndTables] = useLocalStorage('saveRightsForNonItemFieldsAndTables', '');
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);

    var pathname = location.pathname.replace('/', '');
    if (pathname == "") {
        window.open('Home', "_self");
    }
    const [selectedTabIndex, setSelectedTabIndex] = useState(
        (pathname == 'myvineyardsummary') ? 0 :
            ((pathname == 'enterprises' || pathname == 'catchmentcontext') ? 1 : ((pathname == 'outline' || pathname == 'lmu' || pathname == 'infrastructuremap' || pathname == 'waterwaysmap' || pathname == 'mahingakai') ? 2 :
                ((pathname == 'risk' || pathname == 'contaminantevaluation') ? 3 : (pathname == 'infrastructurerisk' || pathname == 'waterwaysrisk' || pathname == 'landsoil' || pathname == 'nutrients') ? 4 : 5))));

    const [pageRefresh] = useState(wizardDetails.pageReload);

    const [selectedMenu, setSelectedMenu] = useState(location.pathname.replace('/', ''));

    const { Step } = Steps;

    const onTabChange = async (firstTab) => {
        if (firstTab == 0) {
            window.open('myvineyardsummary', "_self");
        }
        else if (firstTab == 1) {
            window.open('enterprises', "_self");
        }
        else if (firstTab == 2) {
            window.open('outline', "_self");
        }
        else if (firstTab == 3) {
            window.open('contaminantevaluation', "_self");
        }
        else if (firstTab == 4) {
            window.open('infrastructurerisk', "_self");
        }
        else if (firstTab == 5) {
            window.open('summary', "_self");
        }
    }

    const onStepChange = async (menu) => {
        window.open(menu, "_self");
    }

    const renderWizard = (Model) => {
        const wizardDetails = Model;
        const part1Disabled = pathname == 'myvineyardsummary' ? true : false;
        //Step 1
        /*const part1CompleteddivClass = wizardDetails.isCatchmentContextSaved == true ? "completed-check-show" : "completed-check-not-show";*/
        const part1CompletedClass = wizardDetails.isCatchmentContextSaved == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
        const part2Disabled = pathname == 'myvineyardsummary' ? true : (wizardDetails.isCatchmentContextSaved == true ? false : true);

        //Step 2   
        /*const part2CompleteddivClass = wizardDetails.isMahingaKaiSaved == true ? "completed-check-show" : "completed-check-not-show";*/
        const part2CompletedClass = wizardDetails.isMahingaKaiSaved == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
        const part3Disabled = pathname == 'myvineyardsummary' ? true : (wizardDetails.isMahingaKaiSaved == true ? false : true);

        //Step 3
        let part4Disabled = true;
        let part3CompletedClass = "react-tabs__tab";
        /*let part3CompleteddivClass = "completed-check-not-show";*/

        part3CompletedClass = wizardDetails.isRiskSummarySaved == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
        /*part3CompleteddivClass = wizardDetails.isRiskSummarySaved == true ? "completed-check-show" : "completed-check-not-show";*/
        part4Disabled = pathname == 'myvineyardsummary' ? true : (wizardDetails.isRiskSummarySaved == true ? false : true);


        //Step 4
        let part5Disabled = true;
        let part4CompletedClass = "react-tabs__tab";
        /*let part4CompleteddivClass = "completed-check-not-show";*/

        part4CompletedClass = wizardDetails.isNutrientsSaved == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
        /*part4CompleteddivClass = wizardDetails.isNutrientsSaved == true ? "completed-check-show" : "completed-check-not-show";*/
        part5Disabled = pathname == 'myvineyardsummary' ? true : (wizardDetails.isNutrientsSaved == true ? false : true);

        //Step 5
        /*const part5CompleteddivClass = wizardDetails.isCompleted == true ? "completed-check-show" : "completed-check-not-show";*/
        const part5CompletedClass = wizardDetails.isCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";

        let current = 0;
        let finishedcurrent = 0;

        if (pathname != 'myvineyardsummary') {
            const selectedWizard = wizardDetails.wizardItemList
                .filter(item => item.showInWizard && item.controllerName == pathname)

            wizardDetails.wizardItemList
                .filter(item => item.showInWizard && item.parentSection == selectedWizard[0].parentSection)
                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                .map(function (menuItem, index) {
                    if (menuItem.controllerName == pathname) {
                        current = index;
                    }
                })
        }

        return (
            <Container>
                <Tabs className="Tabs" selectedTabClassName="bg-white" selectedIndex={selectedTabIndex} onSelect={(firstTab) => onTabChange(firstTab)} >
                    <TabList>
                        <Tab className="react-tabs__tab"><label className="step-Name">My Vineyards</label></Tab>
                        <Tab className={part1CompletedClass} disabled={part1Disabled}><label className="step-Name">Part 1 – Property and Catchment</label></Tab>
                        <Tab className={part2CompletedClass} disabled={part2Disabled}><label className="step-Name"> Part 2 – Foundational Mapping</label></Tab>
                        <Tab className={part3CompletedClass} disabled={part3Disabled}><label className="step-Name"> Part 3 – Risk Assessment </label></Tab>
                        <Tab className={part4CompletedClass} disabled={part4Disabled}><label className="step-Name"> Part 4 – Risk Mitigation</label></Tab>
                        <Tab className={part5CompletedClass} disabled={part5Disabled}><label className="step-Name"> Part 5 – Summary</label></Tab>
                    </TabList>
                    <TabPanel></TabPanel>
                    <TabPanel>
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 1')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu, index) => onStepChange(menuItem.controllerName, index)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                    <TabPanel >
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 2')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                    <TabPanel>
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 3')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                    <TabPanel>
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 4')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                    <TabPanel>
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 5')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                </Tabs>
            </Container>
        );

    }

    return (
        <div>
            <div className="wizard-menu">
                {renderWizard(wizardDetails)}
            </div>
        </div >
    );

}

export default WizardMenu;